/*eslint-disable*/
import React from "react";

// reactstrap components
import { Container, Row, Col, Nav, NavItem, NavLink } from "reactstrap";

class AdminFooter extends React.Component {
  render() {
    return (
      <footer className="footer">
        <Row className="align-items-center justify-content-xl-between">
          <Col xl="12">
            <div className="copyright text-center text-muted">
              © {new Date().getFullYear()}
              <a
                className="font-weight-bold ml-1"
                href="https://www.bontempo.com.br/"
                rel="noopener noreferrer"
                target="_blank"
              >
                Bontempo
              </a>
            </div>
          </Col>
        </Row>
      </footer>
    );
  }
}

export default AdminFooter;
